import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { VegaEditorContext } from '../../../../VegaEditorContext'

import { ColorCategorical } from './ColorCategorical'
import { ConfigField } from './ConfigField'

export const GroupFieldConfig = ( { label, prop, validDataset, defaultProps } ) => {
  const { config, updateConfig } = useContext( VegaEditorContext )

  const myConfig = config[prop] ? config[prop] : defaultProps[prop] ? defaultProps[prop] : {}
  const colorScheme = myConfig.scheme ? myConfig.scheme : ''

  function updateGroup( update ) {
    let newConfig = { ...myConfig, ...update }

    updateConfig( { [prop]: newConfig } )
  }

  return (
    <ConfigField
      label={label}
      fieldProp="field"
      field={myConfig.field ? myConfig.field : null}
      accept={['C']}
      onDrop={updateGroup}
      validDataset={validDataset}
    >

      <ColorCategorical
        marginTop="xs"
        label="Color"
        value={colorScheme}
        onUpdate={( clr ) => { updateGroup( { scheme: clr } ) }}
      />
      
    </ConfigField>
  )
}


GroupFieldConfig.propTypes = {
  label: PropTypes.string.isRequired,
  prop: PropTypes.string.isRequired
}
